$("#ajax-sample-suggest").keyup(function(){
  let input = $(this)
  $.ajax({
    type: "GET",
    url: "http://localhost:3000/tags?name_like=" + $(this).val(),
    success: function(results) {
      let names = results.map(result => result.name)
      input.autocomplete({
        source: names,
        select: function(event, ui) {
          let appendedTag = '<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>' + ui.item.value +'</span></a>'
          $("#ajax-sample-tag-area").append(appendedTag)
          $(".js-tag-del").on("click", function() {
            $(this).remove();
          });
        }
      })
    },
    error: function() {
      alert("タグリストの取得に失敗しました。")
    }
  });
})

$("#ajax-sample-genretag-search").on("click", function() {
  $.ajax({
    type: "GET",
    url: "http://localhost:3000/tags?genre_name_like=" + $("#ajax-sample-genretag-text").val(),
    success: function(results) {
      let genreTags= results.map(result => {
        return '<a class="article_tab_tbl_tag article_tab_tbl_tag-add js-tag-add ajax-sample-genre-tag"><span>' + result.name + '</span></a>'
      })
      $("#ajax-sample-genre-tags-area").append(genreTags)
      $(".ajax-sample-genre-tag").on("click", function() {
        let prependedTag = '<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>' + $(this).text() +'</span></a>'
        $("#ajax-sample-tag-area").prepend(prependedTag)
        $(this).remove();
        $(".js-tag-del").on("click", function() {
          $(this).remove();
        });
      });
    },
    error: function() {
      alert("タグリストの取得に失敗しました。")
    }
  });
})
